import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Link from 'next/link';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { dataLayerPush } from '@stelecom/ui-react/components/helpers';
import { IMenuItem } from '~/src/api/content/menu';
import MenuLogo from '~/src/components/MenuLogo';
import CallRequestByTheme from '~/src/components/Popups/CallRequestByTheme';
import TopMenu from '~/src/components/Header/TopMenu';
import RightMenu from '~/src/components/Header/RightMenu';
import MainMenu, { arr } from '~/src/components/Header/MainMenu';
import Profile, { ZERO } from '~/src/components/Header/Profile';
import { ICurrentCity } from '~/src/store/reducers/city';
import { IClientPersonal } from '~/src/store/reducers/auth';
import { useMatchMedia } from '~/src/helpers/hooks/useMatchMedia';
import { EVENTS } from '~/src/constants/analytics';

import * as ST from './styled';
import cookie from 'react-cookies';
import NoSSR from '~/src/helpers/noSSR';
// import geo from '~/static/images/header/geo_new.svg';
import plus from '~/static/images/header/plus.svg';

export enum EMediaWidth {
  desktop = '(min-width: 1366px)',
  tablet = '(max-width: 1365px) and (min-width: 768px)',
  mobile = '(max-width: 767px)',
}

interface IProps {
  items: Record<string, IMenuItem[]>;
  openCitySelect: () => void;
  city: ICurrentCity;
  billingDomain?: string;
  cookieDomain?: string;
  isAuth: boolean;
  logout: () => void;
  clientInfo: IClientPersonal;
  productsInfo: {
    productId: number;
  }[];
  plankIsShown: boolean;
  enableBecomeClientPopup: boolean;
  sendBecomeClient: (data: { name: string; phone: string }) => void;
  modalShow: boolean;
  changeStateModalWindow: () => void;
}

export const PAYMENTS_ITEM_ID = 293;
export const PROMO_ITEM_ID = 303;
export const SERVICE_ITEM_ID = 313;

const SCROLL_TOP = 26;

// const VIDEOCONTROL_ITEM_WEIGHT = 4;
// const DOMOFON_ITEM_WEIGHT = 5;

const burgerOpen = '/static/images/menu/burger.svg';
const burgerClose = '/static/images/menu/cross.svg';

enum EBreakPoints {
  sDesktop = 1365,
}

let oldScrollTopPosition = ZERO;

const Header = ({
  items,
  openCitySelect,
  city,
  billingDomain,
  cookieDomain,
  isAuth,
  logout,
  clientInfo,
  productsInfo,
  plankIsShown,
  enableBecomeClientPopup,
  modalShow,
  changeStateModalWindow
}: IProps): JSX.Element => {
  const {
    TopLeft = [],
    TopMain = [],
    TopRight = [],
    // MobileUnderMenu = [],
  } = items || {};

  const [isFixed, setIsFixed] = useState(false);
  const [isAllItemsView, setIsAllItemsView] = useState(false);
  const [isVisibility, showTopMenu] = useState<boolean>(true);
  const [isBlockedBody, setBlockBody] = useState<boolean>(false);
  const href = useMemo(() => `tel:+${city.phone.replace(/\D/g, '')}`, [city]);
  // const bottomDataDropDown = MobileUnderMenu[ZERO]?.children || [];

  useEffect(() => {
    const onScroll = () => {
      const scrollCondition = window.scrollY >= SCROLL_TOP;
      if (!scrollCondition && isFixed) {
        setIsFixed(false);
      } else if (scrollCondition && !isFixed) {
        setIsFixed(true);
        setIsAllItemsView(false);
      }

      if (window.innerWidth <= EBreakPoints.sDesktop) {
        return;
      }

      let scrollTopPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.body.scrollTop + (document.documentElement?.scrollTop || ZERO);

      scrollTopPosition = scrollTopPosition < 0 ? 0 : scrollTopPosition;

      const scrollConditionForVisibility =
        oldScrollTopPosition > scrollTopPosition;

      const shouldBeVisible =
        scrollTopPosition === 0 || scrollConditionForVisibility;

      if (shouldBeVisible) {
        if (!isVisibility) {
          showTopMenu(true);
        }
      } else if (isVisibility) {
        showTopMenu(false);
      }

      oldScrollTopPosition = scrollTopPosition;
    };

    const throttled = throttle(onScroll, 200, {
      leading: true,
      trailing: true,
    });

    window.addEventListener('scroll', throttled);

    return () => {
      window.removeEventListener('scroll', throttled);
    };
  }, [isVisibility, isFixed]);

  const [isBurgerOpen, setIsBurgerOpen] = useState(false);

  useEffect(() => {
    setBlockBody(isBurgerOpen);
  }, [isBurgerOpen]);

  // const TopMainItems = useMemo(() => {
  //   return TopMain.filter(
  //     (item) =>
  //       item.weight !== VIDEOCONTROL_ITEM_WEIGHT &&
  //       item.weight !== DOMOFON_ITEM_WEIGHT
  //   );
  // }, [TopMain]);

  // const MobileMainMenuItems = useMemo(() => {
  //   const SortedItems = [...TopMain, ...TopRight].sort(
  //     (a, b) => a.weight - b.weight
  //   );
  //   const SortedItemsReduced = SortedItems.reduce((acc: IMenuItem[], item) => {
  //     if (item.id === PAYMENTS_ITEM_ID) {
  //       acc.splice(0, 0, item);
  //     } else if (item.id === SERVICE_ITEM_ID) {
  //       acc.splice(SortedItems.length - 1, 0, item);
  //     } else {
  //       acc.push(item);
  //     }
  //
  //     return acc;
  //   }, []);
  //   SortedItemsReduced.push(SortedItemsReduced.shift() as IMenuItem);
  //   return SortedItemsReduced;
  // }, [TopMainItems, TopRight]);

  // const TabletMainMenuItems = useMemo(() => {
  //   const itemsGeneral = MobileMainMenuItems.filter((item) => {
  //     return (
  //       item &&
  //       item.id !== PAYMENTS_ITEM_ID &&
  //       item.id !== PROMO_ITEM_ID &&
  //       item.id !== SERVICE_ITEM_ID
  //     );
  //   });
  //   const itemPromo = MobileMainMenuItems.filter(
  //     (item) => item && item.id === PROMO_ITEM_ID
  //   );
  //   const ItemService = MobileMainMenuItems.filter(
  //     (item) => item && item.id === SERVICE_ITEM_ID
  //   );
  //   const itemsGeneralReduced = itemsGeneral.reduce(
  //     (acc: Record<string, IMenuItem[]>, item, index) => {
  //       if (index % 2 === 0) {
  //         acc.reducedLeftSide.push(item);
  //       } else {
  //         acc.reducedRightSide.push(item);
  //       }
  //
  //       return acc;
  //     },
  //     {
  //       reducedLeftSide: [],
  //       reducedRightSide: [],
  //     }
  //   );
  //
  //   itemsGeneralReduced.reducedLeftSide.push(...itemPromo);
  //   itemsGeneralReduced.reducedRightSide.push(...ItemService);
  //   return itemsGeneralReduced;
  // }, [MobileMainMenuItems]);

  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const handleClose = () => {
    setIsCallbackOpen(!isCallbackOpen);
  };
  const [isTablet] = useMatchMedia(EMediaWidth.tablet);
  // const [isMobile] = useMatchMedia(EMediaWidth.mobile);
  const [isDesktop] = useMatchMedia(EMediaWidth.desktop);

  const menuItemClick = useCallback((item, menuType = 'Main menu') => {
    closeBurgerHandler();
    dataLayerPush({
      event: EVENTS.UAevent,
      category: `${menuType} click`,
      action: item,
      label: 'menu_new',
    });
  }, []);

  const menuItemHover = useCallback(
    debounce((item, menuType = 'Main menu') => {
      dataLayerPush({
        event: EVENTS.UAevent,
        category: `${menuType} hover`,
        action: item,
        label: 'menu_new',
      });
    }, 700),
    []
  );

  const toggleBurgerHandler = useCallback(() => {
    setIsBurgerOpen(!isBurgerOpen);
  }, [isBurgerOpen]);

  const closeBurgerHandler = useCallback(() => {
    setIsBurgerOpen(false);
  }, []);

  // const openCallbackPopup = useCallback(() => {
  //   setIsCallbackOpen(true);
  //   setIsBurgerOpen(false);
  // }, []);

  const onDisplayAllItems = useCallback(() => {
    setIsAllItemsView(!isAllItemsView);
  }, [isAllItemsView]);

  return (
    <ST.Wrapper
      isAuth={isAuth}
      isFixed={isFixed}
      withPlank={plankIsShown}
      isVisibility={isVisibility}
    >
      <ST.GlobalStyle isBlockedBody={isBlockedBody} />
      <ST.HeaderWrapper>
        <ST.TopWrapper isFixed={isFixed} isVisibility={isVisibility}>
          <ST.DesktopBlock>
            {isTablet ||
              (isDesktop && (
                <TopMenu
                  menuItems={TopLeft}
                  isTablet={isTablet}
                  onClick={menuItemClick}
                  onHover={menuItemHover}
                  isDrop={false}
                  analytics={'Left menu'}
                  openCitySelect={openCitySelect}
                  city={city}
                  isDesktop={isDesktop}
                />
              ))}
            <RightMenu
              openCitySelect={openCitySelect}
              city={city}
              cookieDomain={cookieDomain}
              isAuth={isAuth}
              closeHandler={closeBurgerHandler}
              clientInfo={clientInfo}
              productsInfo={productsInfo}
              logout={logout}
              href={href}
              isDesktop={isDesktop}
              isTablet={isTablet}
              callPopUpHandler={handleClose}
            />
          </ST.DesktopBlock>
        </ST.TopWrapper>
        {
          isAuth ? (<ST.MainWrapper>
            <ST.Logo>
              <Link href='/' passHref>
                <MenuLogo
                    href='/'
                    billingDomain={billingDomain}
                    cityData={city}
                />
              </Link>
            </ST.Logo>
            <MainMenu
                menuItems={TopMain}
                abnTests={city.abnTests}
                isFixed={isFixed}
                isVisibility={isVisibility}
                isAllItemsView={isAllItemsView}
                onClick={menuItemClick}
                onHover={menuItemHover}
                onDisplayAllItems={onDisplayAllItems}
            />
            {isDesktop
? (
                <ST.Right isAuth={isAuth} isAllItemsView={isAllItemsView}>
                  <Profile
                      isAuth={isAuth}
                      productsInfo={productsInfo}
                      clientInfo={clientInfo}
                      logout={logout}
                      closeHandler={closeBurgerHandler}
                      enableBecomeClientPopup={enableBecomeClientPopup}
                      city={city}
                      menuItems={TopRight}
                      onClick={menuItemClick}
                      onHover={menuItemHover}
                      openCitySelect={openCitySelect}
                      isDesktop={isDesktop}
                      isTablet={isTablet}
                      isFixed={isFixed}
                      isVisibility={isVisibility}
                      modalShow={modalShow}
                      changeStateModalWindow={changeStateModalWindow}
                  />
                </ST.Right>
            )
: (
                <ST.BurgerIcon onClick={toggleBurgerHandler}>
                  <ST.Burger
                      width='25px'
                      height='20px'
                      src={isBurgerOpen ? burgerClose : burgerOpen}
                      alt='Меню'
                  />
                </ST.BurgerIcon>
            )}
            <NoSSR>
              {!cookie.load('cityconfirm') && (
                  <ST.BlockForCitySelection>
                    <ST.CitySelectionCustom
                        city={city}
                        cookieDomain={cookieDomain}
                        isAuth={isAuth}
                        onBackClick={() => openCitySelect()}
                        data-test='city-selection'
                    />
                  </ST.BlockForCitySelection>
              )}
            </NoSSR>
          </ST.MainWrapper>)
        : (<ST.CrutchWindow>
                <Profile
                    isAuth={isAuth}
                    productsInfo={productsInfo}
                    clientInfo={clientInfo}
                    logout={logout}
                    closeHandler={closeBurgerHandler}
                    enableBecomeClientPopup={enableBecomeClientPopup}
                    city={city}
                    menuItems={TopRight}
                    onClick={menuItemClick}
                    onHover={menuItemHover}
                    openCitySelect={openCitySelect}
                    isDesktop={isDesktop}
                    isTablet={isTablet}
                    isFixed={isFixed}
                    isVisibility={isVisibility}
                    modalShow={modalShow}
                    changeStateModalWindow={changeStateModalWindow}
                />
              </ST.CrutchWindow>)}

      </ST.HeaderWrapper>
      {!isDesktop && isBurgerOpen && (
        <ST.BurgerMenu withPlank={plankIsShown}>
          <ST.BurgerMenuWrapper isAuth={isAuth}>
            <ST.BurgerCitiesWrapper>
              <a href={'https://stelecom.ru/'}>
                <ST.BurgerCityButton>
                  <img src={plus} alt='' />
                  <p>На основной сайт</p>
                </ST.BurgerCityButton>
              </a>
              <ST.BurgerCityButton onClick={handleClose}>
                <img src={plus} alt='' />
                <p>Перезвоните мне</p>
              </ST.BurgerCityButton>
            </ST.BurgerCitiesWrapper>
            <ST.BurgerPayWrapper>
                <Link href={'/payments'} passHref>
                    <ST.BurgerPayButton text={'Оплатить'} type={'primary'}/>
                </Link>
            </ST.BurgerPayWrapper>
            {/* <ST.DropDownContanerTop>*/}
            {/*  <ST.TopMenuBlock needMobileSt={true}>*/}
            {/*    <TopMenu*/}
            {/*      menuItems={TopLeft}*/}
            {/*      isTablet={isTablet}*/}
            {/*      onClick={menuItemClick}*/}
            {/*      onHover={menuItemHover}*/}
            {/*      isDrop={true}*/}
            {/*      analytics={'Left menu'}*/}
            {/*      openCitySelect={openCitySelect}*/}
            {/*      city={city}*/}
            {/*      isDesktop={isDesktop}*/}
            {/*    />*/}
            {/*  </ST.TopMenuBlock>*/}
            {/*  <ST.TopMenuBlockRight>*/}
            {/*    {city && city.phone ? (*/}
            {/*      <ST.HeaderPhone*/}
            {/*        href={href}*/}
            {/*        className='js-calltouch-phone'*/}
            {/*        data-test='phone'*/}
            {/*      >*/}
            {/*        {city.phone}*/}
            {/*      </ST.HeaderPhone>*/}
            {/*    ) : null}*/}
            {/*    <ST.CallbackLink*/}
            {/*      onClick={openCallbackPopup}*/}
            {/*      as='div'*/}
            {/*      data-test='callback-btn'*/}
            {/*    >*/}
            {/*      Заказать звонок*/}
            {/*    </ST.CallbackLink>*/}
            {/*  </ST.TopMenuBlockRight>*/}
            {/* </ST.DropDownContanerTop>*/}
            {/* <ST.TextMenu>Меню</ST.TextMenu>*/}
            {/* <ST.DropDownContanerBottom>*/}
            {/*  <ST.TopMenuWrapper>*/}
            {/*    <ST.TopMenuBlock isBottom={true}>*/}
            {/*      <TopMenu*/}
            {/*        menuItems={bottomDataDropDown}*/}
            {/*        isTablet={isTablet}*/}
            {/*        onClick={menuItemClick}*/}
            {/*        onHover={menuItemHover}*/}
            {/*        isDrop={true}*/}
            {/*        isBottom={true}*/}
            {/*        colorText={blackColorTextUnderMenu}*/}
            {/*        clickHandler={closeBurgerHandler}*/}
            {/*        analytics={"Right menu"}*/}
            {/*        openCitySelect={openCitySelect}*/}
            {/*        city={city}*/}
            {/*      />*/}
            {/*    </ST.TopMenuBlock>*/}
            {/*  </ST.TopMenuWrapper>*/}
            {/* </ST.DropDownContanerBottom>*/}
            {/* <ST.MainMenuRow>*/}
            {/*  {isTablet && (*/}
            {/*    <>*/}
            {/*      <CardMenu*/}
            {/*        menuItems={TabletMainMenuItems.reducedLeftSide}*/}
            {/*        onClick={menuItemClick}*/}
            {/*        clickHandler={toggleBurgerHandler}*/}
            {/*      />*/}
            {/*      <CardMenu*/}
            {/*        menuItems={TabletMainMenuItems.reducedRightSide}*/}
            {/*        onClick={menuItemClick}*/}
            {/*        clickHandler={toggleBurgerHandler}*/}
            {/*      />*/}
            {/*    </>*/}
            {/*  )}*/}
            {/*  {isMobile && (*/}
            {/*    <CardMenu*/}
            {/*      menuItems={MobileMainMenuItems}*/}
            {/*      onClick={menuItemClick}*/}
            {/*      clickHandler={toggleBurgerHandler}*/}
            {/*    />*/}
            {/*  )}*/}
            {/* </ST.MainMenuRow>*/}
          </ST.BurgerMenuWrapper>
          <ST.BurgerLinksBlock>
            {arr.map(item => {
              return (<Link href={item.link} key={item.id} passHref><ST.LinkItem>{item.name}</ST.LinkItem></Link>);
            })}
          </ST.BurgerLinksBlock>
        </ST.BurgerMenu>
      )}
      <CallRequestByTheme
        isAuth={isAuth}
        isOpen={isCallbackOpen}
        onClose={() => setIsCallbackOpen(false)}
      />
    </ST.Wrapper>
  );
};

export default Header;
